import { coreDealInformation } from '../fields.config';
import GenericSection from '../GenericFormSection/GenericFormSection';

import Services from '../Services';

export const sections = [
  { title: `Core Deal Information`, fields: coreDealInformation, Component: GenericSection },
  { title: `Services`, Component: Services },
];
